module.exports = __webpack_public_path__ + "static/img/1667305396456248.e4b891e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/energy/1667305396456248.jpg
// module id = rZoO
// module chunks = 4